import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTiktok } from 'react-icons/fa';
import Logo from './Logo';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="py-12 bg-white dark:bg-[#0F172A] border-t border-gray-100 dark:border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center justify-center text-center">
        {/* Logo Centrado */}
        <div className="mb-6">
          <Logo className="text-4xl" />
        </div>
        
        {/* Copyright y TikTok */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-gray-600 dark:text-gray-400 font-bold text-base">
            {t('common.footer')}
          </p>
          
          <div className="hidden sm:block w-px h-4 bg-gray-200 dark:bg-gray-800" />
          
          <a 
            href="https://www.tiktok.com/@alfredmenendez" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="w-8 h-8 bg-black dark:bg-white text-white dark:text-black rounded-full flex items-center justify-center hover:scale-110 transition-all shadow-md"
            aria-label="TikTok"
          >
            <FaTiktok size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
}